import { render, staticRenderFns } from "./QuestionFromItem.vue?vue&type=template&id=0a073234&scoped=true&"
import script from "./QuestionFromItem.vue?vue&type=script&lang=ts&"
export * from "./QuestionFromItem.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionFromItem.vue?vue&type=style&index=0&id=0a073234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a073234",
  null
  
)

export default component.exports